
















































import Vue from "vue"
import http from './plugins/http';
import socket from "./plugins/socket";
import { Menu } from "./modules/Menu";
import * as Common from "./commons/common";


export type Datatype = {
  isSignIn: boolean
  user: {login_id: string, name: string, role: string, school_id: string, school_options: object[]}
}

export default Vue.extend({
  computed: {
    userName(): string {
      if(this.$store.state.currentUser){
        const sufix = this.$store.state.currentUser.role == Common.RoleEnum.Student ? "さん" : "先生";
        return `${this.$store.state.currentUser.name}${sufix}`; 
      }else{
        return "";
      }
    },
    isSignIn(): boolean {
      const path: string = this.$route.fullPath;
      return path === "/" || path.indexOf("student_site/sign_in") != -1 || path.indexOf("teacher_site/sign_in_two_factor") != -1;
    }
  },
  async created(): Promise<void> {
    this.$store.dispatch("hideOverlay");
    const inputs = document.getElementsByTagName("input");
    for(var i = 0; i < inputs.length; i++){
      inputs[0].setAttribute("autocomplete", "off");
    }
    await this.searchCurrentInfo();
    // @ts-ignore
    //this.$socket.open();
  },
  methods: {
    to(menu: Menu): void {
      this.$router.push(menu.toUrl).catch((err: any) => {});
    },
    async searchCurrentInfo(): Promise<void> {
      if(this.isSignIn){
        await http.get("/api/master_data/mainte_infos").then((response) =>{
          const mainteInfos = response.data;
          this.$store.commit("setMainteInfo", mainteInfos);
        });
      }else{
        await http.get("/api/current_user").then((response) =>{
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setMainteInfo", response.data.mainte_infos);
        }).catch(error=>{
          if(error.response && error.response.status == 422){
            alert(`${error.response.data.errors[0]}`);
            this.signOut();
          }
        });
      }
    },
    logoClick(){
      if(this.$store.state.currentUser.role == Common.RoleEnum.Student){
        if (this.$store.state.currentUser.to_site_kind == "twenty") {
          this.$router.push(`/student_site/result_student_twenty`).catch(() => {});
        } else if (this.$store.state.currentUser.to_site_kind == "various") {
          this.$router.push(`/student_site/result_student_various`).catch(() => {});
        }
      }else{
        this.$router.push('/teacher_site/sheet_list').catch((err: any) => {});
      }
    },
    signOut(){
      const url = window.location.href;

      // @ts-ignore
      const params = {access_token: document.cookie.match(/access_token=(.*)/)[1]}
      http.post(`/api/logout/${this.$store.state.currentUser.id}`, params).then((response) => {
        document.cookie = 'access_token=';
        // $storeで保持しているログインユーザ情報をクリア
        this.$store.commit("setCurrentUser", null);

        // 教師サイトログイン画面へ
        window.location.href="/#/"
      })
    }
  },
  watch: {
    async "$route" (toUrl: any, fromUrl: any){
      this.$store.dispatch("hideOverlay");
      const inputs = document.getElementsByTagName("input");
      for(var i = 0; i < inputs.length; i++){
        inputs[0].setAttribute("autocomplete", "off");
      }
      if(toUrl !== fromUrl){
        await this.searchCurrentInfo();
      }
      // @ts-ignore
      //this.$socket.close();
      // @ts-ignore
      //this.$socket.open();
    }
  }
});
